module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_5750_Inactive@1x-4f015f3f8264435406b2c096f32746f6.png";